import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import { openModal, closeModal } from 'shared/store/modal'
import { getModalState } from 'shared/store/modal/selectors'

interface IProps {
  closeOnDismountIfType?: string
}

interface IOpenProps {
  type?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
  overrideType?: boolean
}

const useModal = (options?: IProps) => {
  const dispatch = useAppDispatch()
  const { open: isOpen, type, data: modalData } = useAppSelector(getModalState)

  const open = (props?: IOpenProps) => {
    if (!props?.type) {
      dispatch(openModal())
      return
    }

    dispatch(
      openModal({
        type: props.type,
        data: props.data,
        overrideType: props.overrideType,
      })
    )
  }

  const isModalType = (isOpenedType: string) => isOpenedType === type

  const close = () => dispatch(closeModal())

  // To handle dismounting if we are navigating out from anywhere with the back button.
  useEffect(() => {
    return () => {
      if (
        options?.closeOnDismountIfType &&
        options.closeOnDismountIfType === type
      )
        close()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, options?.closeOnDismountIfType])

  return { open, close, isModalType, isOpen, type, modalData }
}

export default useModal
